import React, { useEffect, useState } from 'react';
import { Button, Table, Tag } from 'antd';
import { formatQuantity, formatRefNo } from 'utils/formatter';
import { useNavigate } from 'react-router-dom';
import { DTN_URL } from 'constants/ApiConstants';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { BsTruck } from 'react-icons/bs';

const LedgerView = ({ type, dispatches, businessId }) => {
  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState([]);

  const getColor = (status) => {
    if (status === 'Awaiting Loading') return 'gold';
    if (status === 'Loaded') return 'green';
    if (status === 'In Transit') return 'yellow';
    if (status === 'Goods Delivered') return 'green';
    if (status === 'Goods Rejected') return 'red';
    return 'gold';
  };

  useEffect(() => {
    if (type === 'received') {
      const columns = [
        {
          title: () => <b>Dispatch No</b>,
          dataIndex: 'dispatch',
          key: 'dispatch',
          render: (dispatch, { dispatchRefNo }) => (
            <>
              <b>{dispatchRefNo === 'Total' ? dispatchRefNo : formatRefNo(dispatchRefNo, 'BFD')}</b>
              <br />
            </>
          ),
        },
        {
          title: () => <b>Tracking ID</b>,
          dataIndex: 'trackingId',
          key: 'trackingId',
          render: (dispatch, { dispatchTrackingNo }) => (
            <Button type="link" className="pl-0" onClick={() => window.open(`${DTN_URL}/track/${dispatchTrackingNo}?utm_source=app&utm_medium=web&utm_campaign=link_open&utm_content=${businessId}`)}>
              {dispatchTrackingNo} <HiOutlineExternalLink size={16} />
            </Button>
          ),
        },
        {
          title: () => <b>Product</b>,
          dataIndex: 'product',
          key: 'product',
          render: (dispatch, { product }) => <>{product?.name}</>,
        },
        {
          title: () => <b>Quantity</b>,
          dataIndex: 'dispatchedQty',
          key: 'dispatchedQty',
          render: (dispatch, { dispatchedQty, subUnit }) => (
            <>
              {formatQuantity(dispatchedQty)} {subUnit}
            </>
          ),
        },
        {
          title: () => <b>Sales Bill No</b>,
          dataIndex: 'salesBillNo',
          key: 'salesBillNo',
          render: (dispatch, { salesBillNo }) => <>{salesBillNo ? salesBillNo : '-'}</>,
        },
        {
          title: () => <b>GRN Number</b>,
          dataIndex: 'grnNumber',
          key: 'grnNumber',
          render: (dispatch, { metadata }) => <>{metadata?.grnNumber ? metadata?.grnNumber : '-'}</>,
        },
        {
          title: () => <b>Transit Status</b>,
          dataIndex: 'transitStatus',
          key: 'transitStatus',
          render: (dispatch, { transitStatus }) => (
            <Tag className="rounded px-2 border-0" color={getColor(transitStatus)} icon={<BsTruck className="mr-2" />}>
              {transitStatus}
            </Tag>
          ),
        },
        {
          title: () => <b>Actions</b>,
          dataIndex: 'Actions',
          key: 'Actions',
          render: (dispatch, { _id }) => (
            <Button
              onClick={() => {
                onViewDispatch(_id);
              }}>
              View More
            </Button>
          ),
        },
      ];

      setColumns(columns);
      setTableData([...dispatches]);
    } else {
      const columns = [
        {
          title: () => <b>Dispatch No</b>,
          dataIndex: 'dispatch',
          key: 'dispatch',
          render: (dispatch, { dispatchRefNo }) => (
            <>
              <b>{dispatchRefNo === 'Total' ? dispatchRefNo : formatRefNo(dispatchRefNo, 'BFD')}</b>
              <br />
            </>
          ),
        },
        {
          title: () => <b>Product</b>,
          dataIndex: 'product',
          key: 'product',
          render: (dispatch, { product }) => <>{product?.name}</>,
        },
        {
          title: () => <b>Quantity</b>,
          dataIndex: 'dispatchedQty',
          key: 'dispatchedQty',
          render: (dispatch, { dispatchedQty, subUnit }) => (
            <>
              {formatQuantity(dispatchedQty)} {subUnit}
            </>
          ),
        },
        {
          title: () => <b>Invoice No</b>,
          dataIndex: 'purchaseBillNo',
          key: 'purchaseBillNo',
          render: (dispatch, { purchaseBillNo }) => <>{purchaseBillNo ? purchaseBillNo : '-'}</>,
        },
        {
          title: () => <b>Transit Status</b>,
          dataIndex: 'transitStatus',
          key: 'transitStatus',
          render: (dispatch, { transitStatus }) => (
            <Tag className="rounded px-2 border-0" color={getColor(transitStatus)} icon={<BsTruck className="mr-2" />}>
              {transitStatus}
            </Tag>
          ),
        },
        {
          title: () => <b>Actions</b>,
          dataIndex: 'Actions',
          key: 'Actions',
          render: (dispatch, { _id }) => (
            <Button
              onClick={() => {
                onViewDispatch(_id);
              }}>
              View More
            </Button>
          ),
        },
      ];

      setColumns(columns);
      setTableData([...dispatches]);
    }
  }, [dispatches, type]);

  const onViewDispatch = (id) => {
    if (type === 'received') navigate(`/buy/purchaseorders/dispatch/${id}`);
    else navigate(`/sell/orders/dispatch/${id}`);
  };

  return (
    <Table
      style={{ marginBottom: 0, paddingBottom: 0 }}
      rowClassName={(record, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')}
      size="large"
      bordered={false}
      showHeader={true}
      columns={columns}
      dataSource={tableData}
      scroll={{ x: 1000 }}
    />
  );
};

export default LedgerView;
